import Picker from '@emoji-mart/react'
import { useCallback, useState } from 'react'

import { getPublicUrl } from '@/client/services/url'

import type { EmojiData } from './types'

interface Props {
  onSelect: (emoji: string) => void
}

const EMOJIS_TO_EXCLUDE = ['middle_finger']

export default function EmojiPicker({ onSelect }: Props): React.ReactElement {
  const [data, setData] = useState<EmojiData | null>(null)

  const getData = useCallback(async () => {
    if (data != null) {
      return data
    }

    // console.log(getPublicUrl('emoji-data.json'))

    // console.log('Hi1')

    const response = await fetch(getPublicUrl('emoji-data.json'))
    const newData: EmojiData = await response.json()
    setData(newData)

    return newData
  }, [data])

  return (
    <Picker
      // biome-ignore lint/suspicious/noExplicitAny: TODO: Type this better
      onEmojiSelect={(e: any) => onSelect(e.native)}
      data={getData}
      exceptEmojis={EMOJIS_TO_EXCLUDE}
    />
  )
}
